import { Injectable } from "@angular/core";
import { IAprovadorPedidoDTO } from "../dto/aprovador-pedido-dto";
import { IAprovadorPedido } from "../models/aprovador-pedido";
import { ServiceBase } from "./service.base";
import { AprovadoresPedidoApi } from "../api/aprovador-pedido.api";

@Injectable()
export class AprovadorPedidoService extends ServiceBase<IAprovadorPedido, IAprovadorPedidoDTO> {

    constructor(private api: AprovadoresPedidoApi) {
        super(api);
    }
}